import PanelAlert from '@/components/panel/PanelAlert';
import { lazy, Suspense } from 'react';

const Markdown = lazy(() => import('react-markdown'));

const BaseDescription = ({ description }) => (
  <Suspense fallback={<span>{description}</span>}>
    <Markdown>{description}</Markdown>
  </Suspense>
);

const AuthCredentialsNotesSection = ({ auth }) => {
  const authNotes = auth?.notes;
  const authNotesVariant = auth?.notesVariant;

  if (!authNotes) {
    return null;
  }

  const variant = authNotesVariant || 'info';
  const convertedVariant = variant === 'warning' ? 'warn' : variant === 'danger' ? 'error' : variant;

  return (
    <PanelAlert variant={convertedVariant} className="markdown">
      <BaseDescription description={authNotes} />
    </PanelAlert>
  );
};

export default AuthCredentialsNotesSection;
